/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { Route, RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'chat',
    path: '/chat',
    meta: {
      auth: AUTH_STATE.LOGGED_IN,
      tabbar: (route: Route): string => {
        if (route.query.via === 'play') {
          return 'play/msg';
        }
        return 'secret/msg';
      },
    },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'chat_conversation_list' },
    children: [
      {
        name: 'chat_conversation_list',
        path: 'conversation',
        meta: { title: '聊天会话' },
        component: () => import('@/views/chat/conversation_list'),
      },
      {
        name: 'chat_conversation_detail',
        path: 'conversation/:cid',
        meta: { title: '聊天' },
        component: () => import('@/views/chat/conversation_detail'),
      },
      {
        name: 'chat_conversation_config',
        path: 'conversation/:cid/config',
        meta: { title: '更多' },
        component: () => import('@/views/chat/conversation_config'),
      },
    ],
  },
] as RouteConfig[];
